import { motion, useInView } from 'framer-motion';
import { useRef, useState } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const galleryImages = [
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/e0a1ymv3_IMG_9800%20%281%29.jpeg', alt: 'Adrienne and Thomas' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/wwwxfjrl_IMG_2432.JPG', alt: 'Together' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/gc988d2o_IMG_1288.JPG', alt: 'Memories' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/vt237mp8_IMG_1177%20%281%29.JPG', alt: 'Adventure' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/x4fx8fj6_IMG_0817.jpeg', alt: 'Travels' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/y03e168e_IMG_7187.JPG', alt: 'Joy' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/yhcd86t5_IMG_6684.jpeg', alt: 'Exploring' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/o4g3w6qk_IMG_6245.JPG', alt: 'Love' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/e9ngk0k7_IMG_8964.jpeg', alt: 'Fun' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/4lhso9wi_IMG_3807.JPG', alt: 'Happiness' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/ugyyuohb_IMG_0669.jpeg', alt: 'Sunset' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/su8e6fhq_f33f5ee2-1b8a-440b-a8f5-4a4e7461eae9.JPG', alt: 'Sailing' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/icurxzlv_PHOTO-2025-05-05-16-36-38.jpg', alt: 'Celebration' },
  { src: 'https://customer-assets.emergentagent.com/job_vow-central-3/artifacts/0w9vmuzp_IMG_0137.jpeg', alt: 'Moments' },
];

export const Gallery = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });
  const [lightboxIndex, setLightboxIndex] = useState(null);

  return (
    <section ref={ref} className="py-20 bg-[#EFF4F9]" data-testid="gallery-section">
      <div className="max-w-6xl mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }} className="text-center mb-12">
          <h2 className="font-serif text-4xl sm:text-5xl text-[#1A2B3D] mb-4">{t('galleryTitle')}</h2>
          <div className="wave-divider" />
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {galleryImages.map((image, index) => (
            <motion.div key={image.src} initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.08 }}
              className="aspect-square overflow-hidden rounded-sm cursor-pointer group"
              onClick={() => setLightboxIndex(index)}
              data-testid={`gallery-image-${index}`}>
              <img src={image.src} alt={image.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy" />
            </motion.div>
          ))}
        </div>
      </div>

      {lightboxIndex !== null && (
        <div className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightboxIndex(null)} data-testid="lightbox">
          <button className="absolute top-6 right-6 text-white/80 hover:text-white"
            onClick={() => setLightboxIndex(null)} data-testid="lightbox-close">
            <X className="w-8 h-8" />
          </button>
          <img src={galleryImages[lightboxIndex].src} alt={galleryImages[lightboxIndex].alt}
            className="max-w-full max-h-[85vh] object-contain rounded"
            onClick={(e) => e.stopPropagation()} />
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex gap-2">
            {galleryImages.map((image, i) => (
              <button key={image.src} onClick={(e) => { e.stopPropagation(); setLightboxIndex(i); }}
                className={`w-2 h-2 rounded-full transition-colors ${i === lightboxIndex ? 'bg-white' : 'bg-white/40'}`} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
